import React, { useMemo } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Polygon,
  OverlayView,
} from "@react-google-maps/api";
import { Box } from "@mui/material";

const containerStyle = { width: "100%", height: "100%" };

function getPolygonCenter(points) {
  if (!points || points.length === 0) {
    return { lat: 0, lng: 0 };
  }
  const latSum = points.reduce((sum, p) => sum + p.lat, 0);
  const lngSum = points.reduce((sum, p) => sum + p.lng, 0);
  return {
    lat: latSum / points.length,
    lng: lngSum / points.length,
  };
}

function MapPolygonViewer({ polygons }) {
  const defaultCenter = { lat: 13.75, lng: 100.63 };
  const firstValidPolygon = polygons.find(
    (p) => p.coordinates && p.coordinates.length > 0
  );
  const center = useMemo(
    () =>
      firstValidPolygon
        ? getPolygonCenter(firstValidPolygon.coordinates)
        : defaultCenter,
    [polygons]
  );

  return (
    <Box width="100%" height="100%">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
        {polygons.map((polygon, index) =>
          polygon.coordinates && polygon.coordinates.length > 0 ? (
            <React.Fragment key={index}>
              <Polygon
                paths={polygon.coordinates}
                options={{
                  fillColor: "#00FF00",
                  fillOpacity: 0.3,
                  strokeColor: "#008000",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                }}
              />
              <OverlayView
                position={getPolygonCenter(polygon.coordinates)}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <div
                  style={{
                    background: "#fff",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#1A237E",
                    whiteSpace: "nowrap",
                    minWidth: "120px",
                  }}
                >
                  {polygon.areaType}
                </div>
              </OverlayView>
            </React.Fragment>
          ) : null
        )}
      </GoogleMap>
    </Box>
  );
}

export default MapPolygonViewer;
